import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { dibujarEstrellas, ICONOS_CDR } from "../../../../utils/Tools";

const Contenido = (props) => {
  const [panelActive, setPanelActive] = useState({
    descripcion: "show active",
    condiciones: "",
    ubicacion: "",
  });

  const { hotel } = props || {};
  //const video = producto.multimedia.find(m => m.tipoArchivo === 'V');
  const mapa = hotel.multimedia.find(m => m.tipoArchivo === 'M');

  const setStatusOfPanel = (panel) => {
    setPanelActive({
      descripcion: "",
      condiciones: "",
      ubicacion: "",
      [panel]: "show active",
    });
  };

  return (
    <div className="info col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
      <h2>
        {hotel.nombre} {dibujarEstrellas(Number(hotel.estrellas))}
      </h2>
      <ul className="nav nav-pills cdrColor" id="pills-destino" role="tablist">
        <li className="nav-item">
          <Link
            className={`nav-link ${panelActive.descripcion}`}
            onClick={() => setStatusOfPanel("descripcion")}
            id="pills-descripcion-tab"
            data-toggle="pill"
            to={`#pills-descripcion-${hotel.idHotelWeb}`}
            role="tab"
            aria-controls="pills-descripcion"
            aria-selected="false"
          >
            <i className="material-icons">&#xE0B9;</i> Descripci&oacute;n
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link ${panelActive.condiciones}`}
            to={`#pills-condiciones-${hotel.idHotelWeb}`}
            data-toggle="pill"
            onClick={() => setStatusOfPanel("condiciones")}
            id="pills-condiciones-tab"
            aria-controls="pills-condiciones"
            aria-selected="false"
          >
            <i className="material-icons">&#xE896;</i> Servicios
          </Link>
        </li>
        {mapa && (
          <li className="nav-item">
            <Link
              className={`nav-link ${panelActive.ubicacion}`}
              onClick={() => setStatusOfPanel("ubicacion")}
              id="pills-ubicacion-tab"
              data-toggle="pill"
              to={`#pills-ubicacion-${hotel.idHotelWeb}`}
              aria-selected="false"
            >
              <i className="material-icons">&#xE890;</i> Ubicaci&oacute;n
            </Link>
          </li>
        )}
      </ul>
      <div className="tab-content" id="pills-destino-content">
        {/*Descripcion */}
        <div
          className={`tab-pane fade ${panelActive.descripcion}`}
          id={`pills-descripcion-${hotel.idHotelWeb}`}
          role="tabpanel"
          aria-labelledby="pills-descripcion-tab"
        >
          <p>{hotel.descripcion}</p>
        </div>
        {/*servicios */}
        <div
          className={`tab-pane fade ${panelActive.condiciones}`}
          id={`pills-condiciones-${hotel.idHotelWeb}`}
          role="tabpanel"
          aria-labelledby="pills-condiciones-tab"
        >
          <h6>Servicios del Hotel:</h6>
          {hotel.detalles.map((detalle, i) => {
            return (
              <p
                style={{ display: "inline-block", margin: "0 15px 0 0" }}
                key={i}
              >
                <i className="material-icons alineacionIconoContenido" style={{verticalAlign: 'bottom'}}>
                  {ICONOS_CDR[detalle.nombre]}
                </i>
                {detalle.nombre}
              </p>
            );
          })}
          
          <h6 style={{marginTop: '20px'}}>Politicas de Check In</h6>
          <p>{hotel.politicaCheckIn}</p>
        </div>
        {mapa && (
          <div
            className={`tab-pane text-uppercase fade ${panelActive.ubicacion}`}
            id={`pills-ubicacion-${hotel.idHotelWeb}`}
            role="tabpanel"
            aria-labelledby="pills-ubicacion-tab"
          >
            <p dangerouslySetInnerHTML={{ __html: mapa.url }}></p>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(Contenido);



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/ProductoCuadro/Contenido.js